module.exports = __webpack_public_path__ + "img/tattoo_artist.398a3814.png";